import { $api } from '#/api/client'
import { useUserNav } from '#hooks/useUserNav'

import type { IUserProfile } from '../interfaces'

interface IFetchProfileResponse {
  profile: IUserProfile | undefined
  isLoading: boolean
  isError: boolean
}

export const useFetchProfile = (): IFetchProfileResponse => {
  const userNav = useUserNav()
  const companyId = userNav?.companyId ?? ''
  const userId = userNav?.userId ?? ''

  const { data, isLoading, isError } = $api.useQuery(
    'get',
    '/companies/{companyId}/users/{id}',
    {
      params: {
        path: { companyId, id: userId },
      },
    },
    {
      enabled: Boolean(companyId && userId),
      select: (response): IUserProfile => {
        const mainAddress = response.addresses?.find((a) => a.type === 'main')

        return {
          firstName: response.firstName ?? '',
          lastName: response.lastName ?? '',
          initials: response.initials ?? '',
          infix: response.infix ?? '',
          email: response.email ?? '',
          phoneNumber: response.phoneNumber ?? '',
          birthDate: response.birthDate ?? null,
          address: {
            id: mainAddress?.id ?? null,
            street: mainAddress?.street ?? '',
            houseNumber: mainAddress?.houseNumber ?? '',
            houseNumberSuffix: mainAddress?.houseNumberSuffix ?? '',
            postalCode: mainAddress?.postalCode ?? '',
            city: mainAddress?.city ?? '',
            country: mainAddress?.country ?? '',
          },
          hasPhoto: !!response.userPhotoPath,
          conditionsAgreed: response.conditionsAgreed ?? false,
          conditionsAgreedAt: response.conditionsAgreedAt ?? null,
          createdBy: response.createdBy?.displayName ?? null,
        }
      },
    },
  )

  return {
    profile: data,
    isLoading,
    isError,
  }
}
